// src/components/Footer/Footer.jsx

import React from 'react';
import './footer.css';

const Footer = () => (
  <footer className="footer">
    © {new Date().getFullYear()} CertiLaw. Todos os direitos reservados.
  </footer>
);

export default Footer;
